import { relationGroupsConstants } from '../../_constants';
import { relationGroupsService } from '../../_services';
import { relationGroupsTableActions } from './relationGroupsTable.actions';

export const deleteRelationGroup = {
    deleteRelation
};

function deleteRelation(data) {
    return dispatch => {
        dispatch(request(data));
        relationGroupsService.deleteRelation(data)
            .then(
                relation => {
                    dispatch(relationGroupsTableActions.getRelationGroups());
                    dispatch(success(relation));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(data) { return { type: relationGroupsConstants.REQUEST_DELETE_RELATION,data} }
    function success(relation) { return { type: relationGroupsConstants.RECEIVE_DELETE_RELATION, relation } }
    function failure(error) { return { type: relationGroupsConstants.DELETE_RELATION_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/relationGroups/deleteRelationGroup.action.js